import React from "react";

const CustomAxisTick = (props: any) => {
  const { x, y, payload } = props;
  let num = payload.value;
  if (num >= 1000000000) {
    num = (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "B";
  }
  if (num >= 1000000) {
    num = (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (num >= 1000) {
    num = (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
  }
  num = props.isPercentage ? num + "%" : num;
  return (
    <g transform={`translate(${x - 20},${y - 12})`} fontSize={10}>
      <text x={0} y={0} dy={16} textAnchor="end" fill="#666">
        {num === "0%" || num == 0 ? "" : num}
      </text>
    </g>
  );
};

export default CustomAxisTick;
